import { FC } from 'react';
import styled from 'styled-components';

const Block = styled.div`
  // margin-left: 0 !important;
  // margin-top: 10px;
  // padding: 16px;
  // border-top: 0.5px solid gainsboro;
  // border-bottom: 0.5px solid gainsboro;

  margin-top: 15px;
`;

const Footer: FC = () => {
  return <Block />;
  // return (
  //   <Block className="main-footer text-center">
  //     <strong>Copyright © <a href="https://www.koreapolyschool.com">POLY EFL</a>.</strong> All rights reserved.
  //   </Block>
  // )
}

export default Footer;
